import ContactForm from "../../components/ContactForm/ContactForm";
import "./ProtoContactPageStyles.css";

export default function ProtoContactPage() {
    return(
        <div className="contact-form-container">  
            <ContactForm />
        </div>
    )
}